import React from 'react';
import LightingForm from './LightingForm';
import ClimateForm from './ClimateForm';
import MeasurementForm from './MeasurementForm';
import TentForm from './TentForm';
import FertilizerForm from './FertilizerForm';

/**
 * ProductFormByType - Router-Komponente
 * Wählt das richtige produkttyp-spezifische Formular basierend auf productTypeId
 */
function ProductFormByType({ 
  selectedProductTypeId, 
  productTypes,
  formData, 
  handleChange, 
  handlePhaseChange, 
  handleArrayChange,
  disabled 
}) {
  // Finde den Namen des ausgewählten Produkttyps
  const getProductTypeName = (typeId) => {
    if (!typeId) return null;
    const type = productTypes.find(t => t._id === typeId);
    return type?.name;
  };

  const productTypeName = getProductTypeName(selectedProductTypeId);

  // Wenn kein Produkttyp ausgewählt, zeige nur die Info
  if (!productTypeName) {
    return (
      <div className="product-type-form-section">
        <p className="info-message">
          📝 Bitte wählen Sie einen Produkttyp aus um die produktspezifischen Felder zu sehen.
        </p>
      </div>
    );
  }

  // WICHTIG: Alle Formulare mit vollständiger Bedingung
  if (productTypeName === 'Beleuchtung') {
    return (
      <LightingForm 
        formData={formData}
        handleChange={handleChange}
        handlePhaseChange={handlePhaseChange}
        disabled={disabled}
      />
    );
  }

  if (productTypeName === 'Luft & Klima') {
    return (
      <ClimateForm 
        formData={formData}
        handleChange={handleChange}
        disabled={disabled}
      />
    );
  }

  if (productTypeName === 'Messtechnik') {
    return (
      <MeasurementForm 
        formData={formData}
        handleChange={handleChange}
        disabled={disabled}
      />
    );
  }

  if (productTypeName === 'Growzelte') {
    return (
      <TentForm 
        formData={formData}
        handleChange={handleChange}
        disabled={disabled}
      />
    );
  }

  if (productTypeName === 'Dünger') {
    return (
      <FertilizerForm
        formData={formData}
        handleChange={handleChange}
        handleArrayChange={handleArrayChange}
        disabled={disabled}
      />
    );
  }

  // Fallback für unbekannte Typen
  return (
    <div className="product-type-form-section">
      <p className="info-message">
        📝 Formularbereich nicht definiert für: {productTypeName}
      </p>
    </div>
  );
}

export default ProductFormByType;
